/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import SwanGetFitted from "./swanGetFitted/SwanGetFitted";
import { AttributesContext } from "../context/AttributesContext";
import { MESSAGE_KEY, REACT_APP_CHILD_URL, STORAGE_KEY } from "../services/constant";
import useGetParams from "../hooks/useGetParams";
import Modal from "./modal/Modal";
import useIframeMessaging from "../hooks/useIframeMessaging";
import { useSwanCTA } from "../hooks/useSwanCTA";
import Loading from "./loading/Loading";
import WhatCompoToShow from "./WhatCompoToShow";
import { checkIsToShowCaraousal, getEndpointFitViewScan, removeLocalStorage } from "../utils/Utils";
console.log(window.location.origin,"origin");

const ParentApp = () => {
	const { attributesData } = useContext(AttributesContext);
	const { shopDomain, product, name, callbackUrl } = attributesData ?? {};
	const [details, setDetails] = useState();
	useGetParams({ attributesData, setDetails });
	const [loading, setLoading] = useState(true);
	const [showButton, setShowButton] = useState(true);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [componentToShow, setComponentToShow] = useState();
	const [showDetails, setShowDetails] = useState(false);
	const { isCustom, setupSwanCTA, checkAndSetupCTA, isOnboadedRTW, isOnboadedTryon } = useSwanCTA({
		attributesData,
		details,
		setShowButton,
		setComponentToShow,
		setLoading,
	});
	const resetButton = useCallback(() => {
		setComponentToShow(null);
		setShowDetails(false);
		removeLocalStorage(STORAGE_KEY.SCAN_ID);
	}, []);
	const iframeRef = useRef();
	const handleOpenModal = useCallback(() => {
		setIsModalOpen(true);
	}, []);
	console.log(details);

	const handleShowDetails = () => {
		if (componentToShow) {
			let link = getEndpointFitViewScan({ productHandle: product?.handle, callbackUrl, email: details?.email, shopifyRedirectUrl: details?.shopifyRedirectUrl, shopDomain });
			 const shop = checkIsToShowCaraousal({shopDomain})
			if (isOnboadedRTW && !details?.scanID && !shop) {
				window.location.href = link;
			} else if (!details.faceScanId && isOnboadedTryon && !shop) {
				window.location.href = link;
			} else {
				setShowDetails(!showDetails);
			}
		} else {
			handleOpenModal();
		}
	};

	const hideIframe = useCallback(() => {
		setIsModalOpen(false);
	}, []);

	const messageHandler = useIframeMessaging({
		isCustom,
		details,
		product,
		shopDomain,
		callbackUrl,
		name,
		setDetails,
		setupSwanCTA,
		hideIframe,
	});
	const handleDataTransfer = useCallback(() => {
		if (!iframeRef.current || !iframeRef.current.contentWindow) {
			console.error("Iframe is not available or not loaded yet.");
			return;
		}

		const data = {
			type: MESSAGE_KEY.INFO,
			data: {
				shopDomain,
				productHandle: product?.handle,
				shopify_redirect_url: details?.shopifyRedirectUrl,
				email: details?.email || checkIsToShowCaraousal({ shopDomain }),
				isCustom,
				name,
				callbackUrl,
			},
		};
		setTimeout(() => {
			iframeRef.current.contentWindow.postMessage(data, REACT_APP_CHILD_URL);
		}, 100);
	}, [shopDomain, product, details, isCustom, name, callbackUrl, checkIsToShowCaraousal]);

	useEffect(() => {
		if (isModalOpen) {
			const iframe = iframeRef.current;
			if (iframe) {
				const handleLoad = () => {
					handleDataTransfer(); 
				};
				iframe.addEventListener("load", handleLoad);
				return () => {
					iframe.removeEventListener("load", handleLoad);
				};
			}
		}
	}, [isModalOpen, handleDataTransfer, isCustom, name, shopDomain, details, callbackUrl]);

	useEffect(() => {
		window.addEventListener("message", messageHandler);
		return () => {
			window.removeEventListener("message", messageHandler);
		};
	}, [messageHandler]);

	useEffect(() => {
		if (details) {
			console.log(details, "inside hook");

			checkAndSetupCTA(details);
		}
	}, [details]);

	return showButton ? (
		<>
			{loading && (
				<>
					<Loading height="58px" />
				</>
			)}
			{!loading && !showDetails && <SwanGetFitted loading={loading} data="Discover your fit" handleShowDetails={handleShowDetails} />}
			{!loading && showDetails && (
				<WhatCompoToShow
					shopifyRedirectUrl={details?.shopifyRedirectUrl}
					scanId={details?.scanID}
					email={details?.email}
					resetButton={resetButton}
					productHandle={product?.handle}
					faceScanId={details?.faceScanId}
				>
					{componentToShow}
				</WhatCompoToShow>
			)}
			{isModalOpen && createPortal(<Modal ref={iframeRef} />, document.body)}
		</>
	) : (
		<></>
	);
};

export default ParentApp;
